export default [
  [
    "./images/gif/nl-NL.gif",
    {
      NL: "Nederlands",
      GB: "Engels",
      DE: "Duits",
      FR: "Frans",
    },
  ],
  [
    "./images/gif/en-GB.gif",
    {
      NL: "Dutch",
      GB: "Englisch",
      DE: "German",
      FR: "Frensh",
    },
  ],
  [
    "./images/gif/de-DE.gif",
    {
      NL: "Holländisch",
      GB: "Englisch",
      DE: "Deutsch",
      FR: "Französisch",
    },
  ],
  [
    "./images/gif/fr-FR.gif",
    {
      NL: "Néerlandais",
      GB: "Anglais",
      DE: "Allemand",
      FR: "Français",
    },
  ],
];
